import moment from 'moment';
import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Card, Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Api from '../../services/ApiService';
import ModalTable from './ModalTable';
import ModalList from './ModalList';
import Form from '../form/Form';
import ModalContext from './ModalContext';
import { getCollections, createCollections } from '../../actions/CollectionsActions';
import '../../styles/collections.scss';

const getLayout = customerNo => {
  return [
    {
      data: customerNo,
      hidden: true,
      name: 'customerNo',
    },
    {
      data: '',
      label: 'Contact Name',
      maxLen: 35,
      col: 12,
      name: 'collectionContact',
      required: true,
    },
    {
      data: moment().format('MM-DD-YYYY'),
      label: 'Contact Date',
      col: 3,
      name: 'collectionContactDate',
      required: true,
      type: 'date',
      inputProps: { showToday: true },
    },
    {
      label: 'Contact Time',
      col: 3,
      name: 'collectionContactTime',
      required: true,
      type: 'time',
      data: moment().format('hh:mm:ss'),
    },
    {
      data: '',
      label: 'Promise Amount',
      col: 3,
      name: 'collectionPromiseAmount',
      required: true,
      type: 'currency',
    },
    {
      data: '',
      label: 'Promise Date',
      col: 3,
      name: 'collectionPromiseDate',
      type: 'date',
      inputProps: { showToday: true },
    },
    {
      data: '',
      label: 'Collection Note',
      name: 'collectionNote',
      required: true,
      control: 'Textarea',
    },
  ];
};

const ModalCollection = props => {
  const { lookupKey, title, collections, createCollections, getCollections } = props;
  const [details, setDetails] = useState({});
  const { setTitle } = useContext(ModalContext);
  const layout = getLayout(lookupKey);

  const getNotes = () => {
    getCollections(lookupKey); // TODO doesn't need to live in redux
  };

  const getDetails = () => {
    getNotes(); // 0319
    Api.get(`customer/${encodeURIComponent(lookupKey)}/collectionDetail`).then(response => {
      const newDetails = response.data;
      if (newDetails && typeof newDetails === 'object') {
        setTitle(`${title} (${lookupKey})`);
        delete newDetails.Name;
        setDetails(newDetails);
      }
    });
  };

  useEffect(() => {
    getDetails();
  }, []);

  const submit = payload => {
    const newPayload = {};

    payload.forEach(field => {
      newPayload[field.name] = field.data;
    });

    return createCollections(newPayload);
  };

  const renderTitle = () => {
    let count = 0;

    if (collections && Array.isArray(collections.data)) {
      count = collections.data.length;
    }

    return (
      <div>
        Collection Notes <Badge>{count}</Badge>
      </div>
    );
  };

  return (
    <div className="modal-collections">
      <ModalList data={details} />
      <div className="clearfix" />
      <Card className="mb-3" variant="secondary">
        <Card.Header>
          <Card.Title>{renderTitle()}</Card.Title>
        </Card.Header>
        <Card.Body>
          <ModalTable data={collections.data} headers={collections.headers} />
        </Card.Body>
      </Card>
      <Card variant="secondary">
        <Card.Header>
          <Card.Title>Add Collection Note</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            hideCancel
            layout={layout}
            resetOnSubmit
            submit={submit}
            submitAll
            submitCallback={getNotes}
            trackDirty={false}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

ModalCollection.defaultProps = {
  lookupKey: null,
  collections: { data: [], headers: [] },
};

ModalCollection.propTypes = {
  // Mapped from Redux store
  collections: PropTypes.object,
  createCollections: PropTypes.func,
  getCollections: PropTypes.func,
  // Passed in props
  lookupKey: PropTypes.string,
  title: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getCollections, createCollections }, dispatch);
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCollection);
